import React from 'react';
import { Link } from 'react-router-dom';

/** `items` is [{ label, to }]; the last one is the current page and has no link. */
export default function Breadcrumb({ items }) {
  return <nav className="breadcrumb" aria-label="Breadcrumb">
    {items.map((item, index) => {
      const last = index === items.length - 1;
      return <React.Fragment key={item.label}>
        {last ? <span aria-current="page">{item.label}</span> : <Link to={item.to}>{item.label}</Link>}
        {!last && <span className="breadcrumb__sep" aria-hidden="true">&rsaquo;</span>}
      </React.Fragment>;
    })}
  </nav>;
}
